import { useTranslation } from "react-i18next";

import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

import { Pill } from "./Pill";

export type SplitBy = "none" | "segment";

export function SplitPill({
  value,
  onChange,
}: {
  value: SplitBy;
  onChange: (v: SplitBy) => void;
}) {
  const { t } = useTranslation();
  return (
    <Pill
      label={
        value === "none"
          ? t("demand.pills.split.sum")
          : t("demand.pills.split.splitBySegment")
      }
      isDefault={value === "none"}
    >
      <RadioGroup
        value={value}
        onValueChange={(v) => onChange(v as SplitBy)}
        className="gap-2"
      >
        <Label className="flex cursor-pointer items-center gap-2 py-1">
          <RadioGroupItem value="none" />{" "}
          {t("demand.pills.split.sumOneLineLabel")}
        </Label>
        <Label className="flex cursor-pointer items-center gap-2 py-1">
          <RadioGroupItem value="segment" />{" "}
          {t("demand.pills.split.splitBySegment")}
        </Label>
      </RadioGroup>
    </Pill>
  );
}
